import Signup from './routes/Signup.svelte';
import SignupComplete from './routes/SignupComplete.svelte';
import Settings from './routes/Settings.svelte';
import ClubSettings from './routes/ClubSettings.svelte';
import Login from './routes/Login.svelte';
import LoginPhone from './routes/LoginPhone.svelte';
import Logout from './routes/Logout.svelte';
import Verify from './components/Verify.svelte';
import { wrap } from 'svelte-spa-router/wrap';
import { auth } from './lib/auth';
import { settingsStore } from './stores/settings';
import { get } from 'svelte/store';
import { push } from 'svelte-spa-router';

// Authentication guard - must return boolean for svelte-spa-router
const authGuard = (detail) => {
  const authState = get(auth);
  const settings = get(settingsStore);

  // If still loading, allow the route to load but the component should handle the loading state
  if (authState.loading) {
    return true;
  }

  // Make sure we have a token and user
  if (!authState.token || !authState.user) {
    // Get the current path user was trying to access
    const currentPath = detail.location;

    // Redirect to login with returnTo parameter
    setTimeout(() => push(`/login?return_to=${encodeURIComponent(currentPath)}`), 0);
    return false;
  }

  // Check if user has teams - if not, redirect to complete signup
  // Check for teams with valid IDs (not empty placeholder objects)
  const hasValidTeams = settings.teams && settings.teams.length > 0 && settings.teams.some(team => team.id && team.id.trim() !== '');

  if (!hasValidTeams) {
    // User is authenticated but has no teams - need to complete signup
    setTimeout(() => push('/signup-complete'), 0);
    return false;
  }

  return true;
};

// Unauthenticated guard (redirect to settings if already logged in)
const unauthGuard = () => {
  const authState = get(auth);
  const settings = get(settingsStore);

  // If still loading, wait for auth state to be determined
  if (authState.loading) {
    return true;
  }

  // Only redirect if we have both token and user AND teams (fully authenticated & onboarded)
  // Check for teams with valid IDs (not empty placeholder objects)
  const hasValidTeams = settings.teams && settings.teams.length > 0 && settings.teams.some(team => team.id && team.id.trim() !== '');

  if (authState.token && authState.user && hasValidTeams) {
    // Redirect to settings
    setTimeout(() => push('/settings'), 0);
    return false;
  }
  return true;
};

const routes = {
  // Routes that require authentication
  '/': wrap({
    component: Settings,
    conditions: [authGuard]
  }),
  '/settings': wrap({
    component: Settings,
    conditions: [authGuard]
  }),
  '/club-settings': wrap({
    component: ClubSettings,
    conditions: [authGuard]
  }),
  '/logout': Logout,
  
  // Routes for unauthenticated users
  '/login': wrap({
    component: Login,
    conditions: [unauthGuard]
  }),
  '/login-phone': wrap({
    component: LoginPhone,
    conditions: [unauthGuard]
  }),
  '/signup/:token': wrap({
    component: Signup,
    conditions: []
  }),
  '/signup': wrap({
    component: Signup,
    conditions: [unauthGuard]
  }),
  '/signup-complete': wrap({
    component: SignupComplete,
    conditions: [unauthGuard]
  }),
  '/verify': Verify
};

export default routes; 